import createPersistedState from 'vuex-persistedstate';

import { VUEX_KEY } from '@/enums';
import { secureStorage } from '@/globals';

export default () => {
  const plugins: any = [];

  if (process.env.VUE_APP_PERSIST_STATE === 'true') {
    plugins.push(createPersistedState({
      key: VUEX_KEY,
      // getState: (key, storage) => {
      //   const menus = storage.getItem('browser');
      //   console.log('getState');
      // },
      // setState: (key, state, storage) => {
      //   console.log('getState');
      // },
      storage: {
        getItem: (key) => secureStorage.get(key),
        setItem: (key, value) => secureStorage.set(key, value),
        removeItem: (key) => secureStorage.remove(key)
      }
    }))
  }

  return plugins;
};
